import withLoadingPage from 'HOCs/withLoadingPage';
import BuyCurrencyIcon from 'assets/ver2/icons/header/buy-currency-icon.svg';
import Transactions from 'components/FXTransactions';
import PaginationLazy from 'components/FXTransactions/components/Pagination/mobile';
import SearchTransaction from 'components/FXTransactions/components/SearchTransaction';
import { fetchTransactionsFiltered } from 'components/FXTransactions/func';
import TransactionsMobile from 'components/FXTransactions/mobile';
import {
  redirectToFxTransactionDetails,
  updateNotifyToReaded,
} from 'components/Profile/func';
import ButtonCommon from 'components/common/ButtonCommon';
import CollapsibleSideMenu from 'components/common/CollapsibleSideMenu';
import OuterBodyContent from 'components/common/CollapsibleSideMenu/OuterBodyContent';
import OuterPathContent, {
  Title,
} from 'components/common/CollapsibleSideMenu/OuterPathContent';
import LoadingScreen from 'components/common/LoadingScreen/ver2';
import MobileTabMenu from 'components/common/MobileTabMenu';
import NavbarFooter from 'components/common/NavbarFooter/ver3';
import SizeBox from 'components/common/SizeBox';
import CalculatorModal from 'components/fx/CalculatorModal';
import { FX_SEARCH_BY_DEFAULT, ORDER_EMAIL, PAGE_DEFAULT } from 'constants';
import { FX_TRANSACTION_TABLE_SORT_ORDER_INITIAL } from 'constants/fx';
import Cookies from 'helpers/cookies';
import { FX_MAKE_PAYMENT_KEY } from 'hooks/fx/useFxAddTransaction';
import useFxFormAddTransactionStore from 'hooks/fx/useFxFormAddTransactionStore';
import useAuth from 'hooks/useAuth';
import useBodyContentStatus from 'hooks/useBodyContentStatus';
import { useDetectDevice } from 'hooks/useDetectDevice';
import useLang from 'hooks/useLang';
import useQuery from 'hooks/useQuery';
import useStore from 'hooks/useStore';
import { isArray, isEmpty, isNull } from 'lodash';
import { useEffect, useState } from 'react';

const FxTransactionsPageWithLoading = withLoadingPage(LoadingScreen);

const TransactionsPage = () => {
  const { t } = useLang();
  const { state } = useStore();
  const { token } = useAuth();
  const { isMobile, isTablet, isDesktop } = useDetectDevice();
  const query = useQuery();
  const tid = query.get('tid');
  const mid = query.get('mid');
  const { refreshTransactionsList } = state;

  const { isMenuExpand, notifications } = state; // For Collapsible Menu

  const [transactions, setTransactions] = useState(null);
  const [currentPage, setCurrentPage] = useState(PAGE_DEFAULT);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [sortOrder, setSortOrder] = useState(
    FX_TRANSACTION_TABLE_SORT_ORDER_INITIAL
  );

  const [applyFiltered, setApplyFiltered] = useState(null);
  const [searchValue, setSearchValue] = useState('');
  const [currentSearchBy, setCurrentSearchBy] = useState(FX_SEARCH_BY_DEFAULT);
  const [isFetching, setFetching] = useState(false);
  const [isShowCalculatorModal, setShowCalculatorModal] = useState(false);

  const { resetAddTransactionInformation } = useFxFormAddTransactionStore();

  const {
    isShowSearchInput,
    isShowFilterButton,
    isShowActionButton,
    isShowPagingButton,
    isShowPillFiltered,
  } = useBodyContentStatus({
    isFetching,
    list: transactions,
    sorts: sortOrder,
    filters: applyFiltered,
    search: searchValue,
  });

  useEffect(() => {
    if (notifications && Array.isArray(notifications) && tid && mid) {
      const notiData = notifications?.find(
        (noti) => noti?.data?.tranId === tid && noti?.uuid === mid
      );

      if (notiData) {
        if (!notiData?.read) {
          updateNotifyToReaded(currentUser, notiData);
        }
        redirectToFxTransactionDetails(token, notiData, navigate);
      }
    }
  }, [notifications, tid, mid]);

  const isFetchTransactionsInitial =
    token &&
    !isArray(transactions) &&
    isEmpty(transactions) &&
    !searchValue &&
    isEmpty(applyFiltered) &&
    Object.values(sortOrder).every((value) => !value) &&
    refreshTransactionsList;

  useEffect(() => {
    if (isFetchTransactionsInitial) {
      setFetching(true);
      setTransactions(null);
      fetchTransactionsFiltered({
        token,
        page: PAGE_DEFAULT,
        transactions: [],
        setTransactions,
        setCurrentPage,
        setTotalPages,
        setTotalElements,
        setFetching,
      });
    }
  }, [isFetchTransactionsInitial]);

  const handleOnShowCalculatorModal = () => {
    Cookies.remove(FX_MAKE_PAYMENT_KEY);
    Cookies.remove(ORDER_EMAIL);
    resetAddTransactionInformation();
    setShowCalculatorModal(true);
  };
  const handleOnCloseCalculatorModal = () => {
    setShowCalculatorModal(false);
  };

  const renderSearchInput = () => {
    if (!isShowSearchInput) return null;
    return (
      <SearchTransaction
        applyFiltered={applyFiltered}
        currentSearchBy={currentSearchBy}
        setCurrentSearchBy={setCurrentSearchBy}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        transactions={transactions}
        setTransactions={setTransactions}
        setTotalPages={setTotalPages}
        setCurrentPage={setCurrentPage}
        setSortOrder={setSortOrder}
        setTotalElements={setTotalElements}
        setFetching={setFetching}
      />
    );
  };
  const renderFilterButton = () => {
    if (!isShowFilterButton) return null;
    return null;
  };
  const renderActionButton = () => {
    if (!isShowActionButton) return null;
    if (!isDesktop) return null;
    return (
      <ButtonCommon
        value={t('fx_buy_currency_label')}
        color="var(--c-primary)"
        background="var(--bg-primary)"
        isFill={true}
        styles={{
          paddingInline: 0,
        }}
        buttonIconStyles={{
          float: 'right',
        }}
        iconSrc={BuyCurrencyIcon}
        onClick={handleOnShowCalculatorModal}
      />
    );
  };
  const renderPagingButton = () => {
    if (!isShowPagingButton) return null;
    if (!isDesktop)
      return (
        <PaginationLazy
          applyFiltered={applyFiltered}
          searchValue={searchValue}
          currentSearchBy={currentSearchBy}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalPages={totalPages}
          transactions={transactions}
          setTransactions={setTransactions}
        />
      );
    return null;
  };
  const renderFilteredPills = () => {
    if (!isShowPillFiltered) return null;
    return null;
  };
  const renderSearchFilterActionPagingSection = () => {
    return (
      <>
        {renderSearchInput()}
        {renderFilterButton()}
        {renderActionButton()}
        {renderPagingButton()}
        {renderFilteredPills()}
      </>
    );
  };

  const renderTransactionsSection = () => {
    if (isFetchTransactionsInitial) return;
    if (!isDesktop)
      return (
        <TransactionsMobile
          transactions={transactions}
          setTransactions={setTransactions}
          searchValue={searchValue}
          applyFiltered={applyFiltered}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          sortOrder={sortOrder}
          setTotalElements={setTotalElements}
          setTotalPages={setTotalPages}
          isFetching={isFetching}
          setFetching={setFetching}
          totalPages={totalPages}
          totalElements={totalElements}
        />
      );
    return (
      <Transactions
        currentPage={currentPage}
        totalPages={totalPages}
        transactions={transactions}
        setTransactions={setTransactions}
        applyFiltered={applyFiltered}
        searchValue={searchValue}
        setTotalPages={setTotalPages}
        setCurrentPage={setCurrentPage}
        sortOrder={sortOrder}
        setSortOrder={setSortOrder}
        totalElements={totalElements}
        setTotalElements={setTotalElements}
        isFetching={isFetching}
        setFetching={setFetching}
      />
    );
  };

  const getOuterPathContentStyle = () => {
    if (!isDesktop) return {};
    return {
      minHeight: '80vh',
    };
  };

  if (isMobile || isTablet) {
    return (
      <>
        {isShowCalculatorModal && (
          <CalculatorModal
            isOpen={isShowCalculatorModal}
            onClose={handleOnCloseCalculatorModal}
          />
        )}
        {isNull(transactions) &&
          isEmpty(applyFiltered) &&
          isEmpty(searchValue) && <FxTransactionsPageWithLoading />}
        <OuterBodyContent>
          <MobileTabMenu />
          {renderSearchFilterActionPagingSection()}
          {renderTransactionsSection()}
          <NavbarFooter />
        </OuterBodyContent>
      </>
    );
  }
  return (
    <>
      {isShowCalculatorModal && (
        <CalculatorModal
          isOpen={isShowCalculatorModal}
          onClose={handleOnCloseCalculatorModal}
        />
      )}
      {isNull(transactions) &&
        isEmpty(applyFiltered) &&
        isEmpty(searchValue) && <FxTransactionsPageWithLoading />}
      <CollapsibleSideMenu>
        <OuterBodyContent>
          <OuterPathContent style={getOuterPathContentStyle()}>
            <Title>{t('transactions_title')}</Title>
            <SizeBox height={16} />
            {renderSearchFilterActionPagingSection()}
            {renderTransactionsSection()}
          </OuterPathContent>
        </OuterBodyContent>
      </CollapsibleSideMenu>
    </>
  );
};

export default TransactionsPage;
